import { createContext, useContext } from 'react';

import type { RequirementFlagSettingsDocument } from 'types';

const FlagSettingsContext = createContext<RequirementFlagSettingsDocument[]>([]);
const FlagMappingErrorsContext = createContext<Record<string, string>>({});

export const FlagSettingsProvider = FlagSettingsContext.Provider;
export const FlagMappingErrorsProvider = FlagMappingErrorsContext.Provider;

export const useFlagSettings = () => useContext(FlagSettingsContext);
export const useFlagMappingErrors = () => useContext(FlagMappingErrorsContext);
